import "./common.styles.scss";
import { setScribeActiveSuccess } from "../../store/scribe/action";
import { useDispatch, useSelector } from "react-redux";
import React from "react";

export default function ScribeHelper() {
  const dispatch = useDispatch();

  const iFramingHelper = (
    <iframe
      src="https://scribehow.com/embed/Creating_a_new_customer_profile_for_Pauls_Factory__W8KlFeMpQJi_UsVsY6Gb3Q?as=scrollable&skipIntro=true"
      width="100%"
      height="100%"
      allowFullScreen
      frameBorder="0"
    ></iframe>
  );

  return (
    <div className={"scribe-helper-main-frame"}>
      {iFramingHelper}
      <div
        className={"btn w-100 btn-danger scribe-helper-close-button"}
        onClick={() => {
          dispatch(setScribeActiveSuccess(false));
        }}
      >
        <span className={"  "}>
          {/*icon circle x*/}
          <i className="fa-regular fa-circle-xmark"></i>
        </span>
        <span className={"ps-1  "}>Close</span>
      </div>
    </div>
  );
}

export function ScribeHelperButton({ Id, title }) {
  const dispatch = useDispatch();
  return (
    <div className={"scribe-helper-button-main-frame"}>
      {title && (
        <span
          style={{
            fontFamily: "Montserrat, sans-serif",
            fontWeight: "700",
            fontSize: "15px",
          }}
        >
          {title}
        </span>
      )}

      <span
        title={"Need Help ? Click here"}
        onClick={() => {
          dispatch(setScribeActiveSuccess(true));
          // todo: pass Id later to api to get iframe scribe src
        }}
        className={"scribe-helper-button"}
      >
        {/*icon circle x*/}
        <i className="fa-regular fa-circle-question"></i>
      </span>
    </div>
  );
}
